export interface PropertyLeaseConditionsDto {
  id: string;
  possibleLeaseTerms: PossibleLeaseTerms[] | null;
  rent: number | null;
  securityDeposit: LeaseConditionIncome | null;
  desiredLeasingDate: string | null;
}

export enum PossibleLeaseTerms {
  MONTHLY = 'Month to Month',
  SIX_MONTHS = '6 Months',
  ONE_YEAR = '12 Months',
  RENT_TO_OWN = 'Rent to Own',
  OTHER = 'Other',
}

export enum LeaseConditionIncome {
  X0_5_RENT = '0.5x monthly rent',
  X1_RENT = '1x monthly rent',
  X2_RENT = '2x monthly rent',
  X2_5_RENT = '2.5x monthly rent',
  X3_RENT = '3x monthly rent',
  X3_5_RENT = '3.5x monthly rent',
  NO_REQUIREMENT = 'No requirement',
}
